declare var $: any;

export class TextBox {
    $el: any;

    constructor($textBox: any) {
        this.$el = $textBox;
    }

    hideValidationError() {
        const $container = this.$el.parent(".text-box-container--inner");
        const $validationMessage = $container.siblings(".field-validation-error");

        $container.removeClass("validation-error");
        this.$el.removeClass("input-validation-error");
        $validationMessage.removeClass("field-validation-error");
        $validationMessage.addClass("field-validation-valid");
        $validationMessage.text("");
    }
}



// WEBPACK FOOTER //
// ./assets/scripts/components/textBox.ts